import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Drawer,
  Badge,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../HomeNavbar/Sidebar";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../api/Api";
import { ToastContainer, toast } from "react-toastify";
import settings from "../../assets/img/settings.png";
import bailIcon from "../../assets/img/bailIcon.png";
import { getAllBulkOrders } from "../../api/Api";
const DashboardNav = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [bulkOrders, setBulkOrders] = useState([]);
  const [pendingOrdersCount, setPendingOrdersCount] = useState(0);

  const menuItems = [
    { label: "Home", path: "/" },
    { label: "Dashboard", path: "/Dashboard" },
    { label: "Products", path: "/ProductDashboard" },
  ];
  useEffect(() => {
    const fetchBulkOrders = async () => {
      try {
        const response = await getAllBulkOrders();
        if (response.status === 200) {
          const orders = response.data.result;
          setBulkOrders(orders);

          // Filter and count pending orders
          const pendingCount = orders.filter(
            (order) =>
              order.paymentStatus === "Pending" ||
              order.deliveryStatus === "Pending"
          ).length;

          setPendingOrdersCount(pendingCount);

          // Store the count locally
          localStorage.setItem("pendingOrdersCount", pendingCount);

          // console.log("Bulk Orders:", orders);
          // console.log("Pending Orders Count:", pendingCount);
        } else {
          console.error("Failed to fetch bulk orders:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching bulk orders:", error);
      }
    };

    fetchBulkOrders();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
  };

  const handleLogout = async () => {
    setIsClicked(true);
    setLoading(true);
    try {
      const data = localStorage.getItem("pd");
      if (data) {
        const parsedData = JSON.parse(data);
        const { email } = parsedData.user;

        const response = await logout(email);
        if (response.status === 200 || response.success) {
          // Remove specific keys from localStorage
          localStorage.removeItem("pd");
          localStorage.removeItem("AllOrders");
          localStorage.removeItem("orders");
          localStorage.removeItem("todayOrders");
          localStorage.removeItem("todaysOrders");
          localStorage.removeItem("totalOrders");
          localStorage.removeItem("monthlyOrders");

          // Navigate to the logout dashboard after successful logout
          navigate("/LogoutDashboard");
          setLoading(false); // Stop loading animation
        } else {
          throw new Error("Failed to logout.");
        }
      } else {
        console.log("User is not signed in.");
        setIsClicked(false);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error during logout:", error);

      // Navigate to error page on logout failure
      navigate("/ErrorDashboard");
      setLoading(false); // Stop loading animation
    }
  };

  const handleNotificationClick = () => {
    navigate("/Bulkorders");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: theme.palette.primary.main,
          boxShadow: "none",
          paddingTop: "15px",
        }}
      >
        <Toolbar
          sx={{
            justifyContent: { md: "space-between", xs: "space-between" },
            px: { xs: 2, md: 2 },
            py: { xs: 2, md: 2 },
            position: "relative",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "30%",
              marginLeft: { xs: 0, md: "1vw" },
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleSidebar}
              sx={{
                display: { xs: "block", md: "block" },
                marginLeft: { xs: 0, md: 0 },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="40px"
                viewBox="0 0 24 24"
                width="40px"
                fill="#FFFFFF"
              >
                <path d="M0 0h24v24H0V0z" fill="none" />
                <path d="M4 18h16v-2H4v2zm0-5h16v-2H4v2zm0-7v2h16V6H4z" />
              </svg>
            </IconButton>

            <Typography
              variant="h6"
              component="div"
              sx={{
                color: "#FFFFFF",
                fontSize: { xs: "1.4rem", md: "1.8rem" },
                fontFamily: "Poppins, sans-serif",
                fontWeight: "bold",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
                width: { xs: "80%", md: "auto" },
              }}
            >
              Drips Water
              {/* Adi Aqua Ltd. */}
            </Typography>
          </Box>

          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "left",
              width: { xs: "100%", sm: "50%", md: "45%", lg: "40%" },
            }}
          >
            <Badge
              color="error"
              badgeContent={pendingOrdersCount > 0 ? pendingOrdersCount : null}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: "0.8rem",
                  minWidth: "16px",
                  height: "16px",
                },
              }}
            >
              <IconButton
                color="inherit"
                sx={{ marginLeft: "4vw" }}
                onClick={handleNotificationClick}
              >
                <img
                  src={bailIcon}
                  alt="Notification Icon"
                  style={{ height: "25px", width: "25px" }}
                />
              </IconButton>
            </Badge>

            {menuItems.map((item) => (
              <Button
                key={item.label}
                color="inherit"
                sx={{
                  color: isActive(item.path) ? "#00CFFF" : "#FFFFFF",
                  ml: 2,
                  textTransform: "capitalize",
                  fontSize: "1.1rem",
                  "&:hover": {
                    color: "#00CFFF",
                  },
                }}
                onClick={() => handleMenuItemClick(item.path)}
              >
                {item.label}
              </Button>
            ))}

            <Box sx={{ ml: 2, display: "flex", alignItems: "center", gap: 2 }}>
              <Button
                variant="contained"
                sx={{
                  ml: 4,
                  margin: "auto",
                  width: isClicked ? "9vw" : "7vw",
                  display: "block",
                  padding: "10px",
                  backgroundColor: isClicked
                    ? theme.palette.primary.light
                    : theme.palette.primary.light,
                  borderRadius: isClicked ? "10px" : "20px",
                  color: isClicked ? "#fff" : "#fff",
                  textTransform: "capitalize",
                }}
                onClick={handleLogout}
                disabled={loading} // Disable button while loading
              >
                {loading ? (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.1rem",
                      color: "#fff",
                    }}
                  >
                    Processing
                    <Box
                      component="img"
                      src={settings}
                      alt="Loading"
                      sx={{
                        width: "1.5rem",
                        height: "1.5rem",
                        animation: "spin 3s linear infinite",
                        filter: "invert(1)",
                        marginLeft: "auto", // Pushes the icon to the right
                      }}
                    />
                  </Box>
                ) : (
                  "Signout"
                )}
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              position: "absolute",
              top: -20,
              right: 0,
              zIndex: -1,
            }}
          >
            <svg
              width="260"
              height="258"
              viewBox="0 0 226 218"
              fill="#C7E7FF"
              xmlns="http://www.w3.org/2000/svg"
            >
              <ellipse
                cx="236.5"
                cy="16.5"
                rx="236.5"
                ry="201.5"
                fill="#C7E7FF"
              />
            </svg>
          </Box>
        </Toolbar>
      </AppBar>

      <Drawer anchor="left" open={isSidebarOpen} onClose={toggleSidebar}>
        <Sidebar toggleSidebar={toggleSidebar} />
      </Drawer>

      <ToastContainer />

      {/* Inline CSS for spin animation */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default DashboardNav;
